import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

/**
 * Note Number video card overlay — reference markup:
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *     > 6 × <div><span><img></span></div>
 * Collapsed (.hide-cards) while the first card is still "1" or after the shuffle handle is clicked.
 */
export default function NoteNumCardsOverlay({ cardString }) {
  const [showCards, setShowCards] = useState(true);
  if (!cardString) return null;
  const cards = String(cardString).split(",").map((c) => c.trim());
  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={hidden ? "casino-video-cards hide-cards" : "casino-video-cards"}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <React.Fragment key={i}>
            {i > 0 ? " " : null}
            <div>
              <span>
                <CardImg src={getCardImage(cards[i])} alt="" />
              </span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
